<template>
  <li class="nav-item"  :class="'layer'+layer" @click="navClick(data)">
    <div class="nav-item-text">{{data.name}}</div>
    <ul v-if="data.children" class="nav-item-ul" >
      <nav-item v-for="(item, index) in data.children" :key="index" :data="item" :layer="layer+1" @pageSkip="pageSkip"></nav-item>
    </ul>
  </li>
</template>

<script>
  export default {
    name: "NavItem",
    props: {
      data: Object,
      layer: Number
    },
    data() {
      return {
      };
    },
    methods: {
      navClick(route) {
        if (route.path) {
          if (this.$router.currentRoute.path !== route.path) {
            if(route.path.indexOf("http") != -1){
              window.open(route.path,"_blank");
            }
            else{
              this.$router.push({
                path: route.path,
              });
            }
          }
          this.$emit('pageSkip');
        }
      },
      pageSkip(){
        this.$emit('pageSkip');
      }
    }
  }

</script>

<style scoped>
 .pc-box .nav-item-container .layer1{
     line-height: 40px;
     font-size: 15px;
     padding: 0;
     position: relative;
     cursor: pointer;
   }
 .pc-box .nav-item-container .layer1:hover{
     background: #f5f5f5;
   }
 .pc-box .nav-item-container .layer1>.nav-item-text{
     padding: 0 20px;
     white-space: nowrap;
     transition: color .2s ease;
   }
 .pc-box .nav-item-container .layer1:hover>.nav-item-text{
     color:#333;
   }
 .pc-box .nav-item-container .layer2{
     line-height: 34px;
     font-size: 13px;
     padding: 0;
   }
 .pc-box .nav-item-container .layer2>.nav-item-text{
     padding: 0 20px;
     white-space: nowrap;
   }
 .pc-box  .nav-item-container .layer2:hover{
     color: #eb580e;
     background: #fafafa;
   }
  .nav-item {
    width: 100%;
    height: auto;
  }
  .nav-item {
    position: relative;
  }
  .nav-item ul{
    position: absolute;
    left: 100%;
    top: 0;
    min-width: 180px;
    background: #fff;
    box-shadow: 0 4px 12px rgba(0,0,0,.12);
    border-radius: 4px;
    overflow: hidden;
    opacity: 0;
    visibility: hidden;
    transform: translateX(4px);
    transition: opacity .25s ease, transform .25s ease, visibility .25s ease;
    z-index: 10;
    padding: 8px 0;
  }
  .nav-item:hover>ul{
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
  }
  .nav-item ul li{
    height: auto;
    max-height: none;
    padding: 0;
    line-height: 36px;
    transition: none;
  }
  .nav-item ul li .nav-item-text{
    padding: 0 16px;
    white-space: nowrap;
  }
  .nav-item ul li:hover{
    background: #f5f5f5;
  }

</style>



// WEBPACK FOOTER //
// src/components/NavMenu/NavItem.vue